"use client";

import { Logo } from "@/components/brand/Logo";

/**
 * Pełnoekranowy splash z logo + spinner. Pokazywany dopóki essential
 * Firestore queries nie dostarczą pierwszego snapshotu.
 */
export function Splash() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-bg gap-6">
      <div className="animate-pulse">
        <Logo variant="mark" size={64} />
      </div>
      <div className="flex gap-1.5">
        <span className="h-2 w-2 rounded-full bg-accent animate-bounce [animation-delay:-0.3s]" />
        <span className="h-2 w-2 rounded-full bg-accent animate-bounce [animation-delay:-0.15s]" />
        <span className="h-2 w-2 rounded-full bg-accent animate-bounce" />
      </div>
    </div>
  );
}
